import { TextInputProps } from "@/ui/forms/TextInput";
import { TextInput } from "@/ui";
import { Field } from "formik";

export type FormikInputProps = Exclude<
    TextInputProps,
    "value" | "onChange" | "onBlur" | "error"
>;

export default function FormikInput({ name, ...rest }: FormikInputProps) {
    return (
        <Field name={name}>
            {({ field, form: { touched, errors }, meta }) => (
                <TextInput
                    name={name}
                    error={touched[name] ? errors[name] : undefined}
                    {...rest}
                    {...field}
                />
            )}
        </Field>
    );
}
